/*Recurso: Files - Servicio de lectura del API: Verifica la autenticación del usuario obteniendo clave y contraseña
  Tareas:
    UploadFilesDecision              //*RP
    UploadFilesAnalysis              //*RD
*/

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + 'Files/';

  //se genera una función por cada tarea del recurso api
    
    //tarea: UploadFilesDecision 
    const cargaUploadFilesDecision = async (token:any, formData:any) => {
      //console.log ('***API: ' + API_URL + 'UploadFilesDecision',  {headers: { 'content-type': 'text/json' }} );
      //console.log ('***API-body: ', formData )
      return await axios.post(API_URL + 'UploadFilesDecision', formData,
        { headers: { 'Authorization':token }} )
    };

    //tarea: UploadFilesAnalysis 
    const cargaUploadFilesAnalysis = async (token:any, formData:any) => {
      //console.log ('***API: ' + API_URL + 'UploadFilesAnalysis',  {headers: { 'content-type': 'text/json' }} );
      //console.log ('***API-body: ', formData )
      return await axios.post(API_URL + 'UploadFilesAnalysis', formData,
        { headers: { 'Authorization':token }} )
    };
    
  const filesService = {
      cargaUploadFilesDecision: cargaUploadFilesDecision,
      cargaUploadFilesAnalysis: cargaUploadFilesAnalysis,
  };

export default filesService;
